
    import * as React from 'react';

    const Checkmark16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M2.732 9.458l-.464.59 4.44 3.494 7.101-10.33-.618-.424-6.648 9.67z" /></svg>
        </div>
      );
    };

    Checkmark16.displayName = 'Checkmark16';

    export default Checkmark16;
  